import { render, staticRenderFns } from "./SysBgCrk.vue?vue&type=template&id=195647a5&scoped=true&"
import script from "./SysBgCrk.vue?vue&type=script&lang=js&"
export * from "./SysBgCrk.vue?vue&type=script&lang=js&"
import style0 from "./SysBgCrk.vue?vue&type=style&index=0&id=195647a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195647a5",
  null
  
)

export default component.exports